<template>
    <div 
        class="page_viewport"
        v-on:click.self="(e) => {clearActiveElements(e)}"
    >
        <div class="page_start_size">
            <PageBlank
                :page="page"
                ref="pageBlank"
            />
        </div>
    </div>
</template>

<script>
    import PageBlank from './PageBlank.vue'
    import { mapGetters } from 'vuex';

    export default {
        props: ['page'],
        methods: {
            clearActiveElements(e) {
                this.$store.dispatch('DISABLE_ELEMENTS_ON_PAGE');
            },
            viewportHeight() {
                return this.$el.offsetHeight;
            },
            startSize() {
                this.$el.children[0].style.width = this.viewportHeight() + 'px'
                this.$el.children[0].style.height = this.viewportHeight() + 'px'
            }
        },
        computed: {
            ...mapGetters([
                'getProject'
            ])
        },
        mounted() {
            this.viewportHeight();
            this.startSize();
        },
        components: {
            PageBlank
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .page_viewport {
        flex-grow: 1;
    }
    .page_start_size {
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>